export default "__VITE_ASSET__DYWlZSAc__"